import { render, staticRenderFns } from "./sales-by-territory.vue?vue&type=template&id=14887399"
import script from "./sales-by-territory.vue?vue&type=script&lang=js"
export * from "./sales-by-territory.vue?vue&type=script&lang=js"
import style0 from "./sales-by-territory.vue?vue&type=style&index=0&id=14887399&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports